import React from 'react';
import { CircularProgress, Box } from '@mui/joy';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useLoadOne } from 'src/mtska-frontend-data-provider/hooks/useLoadOne.hooks';
import Create from './Create';
import { Backdrop } from "@mui/material"

const dataProviderName = 'audiences/audiencesegment';
const model = 'audiences/audienceSegment';

const Detail = (params) => {
    const { item, loadOne, errorMessage, saving, reloadCounter, doAction } = useDataProvider(dataProviderName, params.multipart);

    useLoadOne({ loadOne, params, reloadCounter });
    const requestedId = params?.id ? String(params.id) : null;
    const currentItemId = item?.data?.id ? String(item.data.id) : (item?.data?._id ? String(item.data._id) : null);
    const isMismatchedItem = !!requestedId && !!currentItemId && requestedId !== currentItemId;

    const handleSave = (data) => {
        const payload = { ...data, filters: params.filters };
        return doAction({
            action: 'actionUpdate',
            model: model,
            data: payload
        }).then(result => params.handleClose?.(params.uid, result))
            .catch(error => console.error(error));
    };

    if (!item?.data || isMismatchedItem) return <Backdrop open={true} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop>;

    return (
        <Create
            {...params}
            item={item?.data || {}}
            defaultRules={item?.data?.rules || []}
            wizardAction="actionUpdate"
            onSave={handleSave}
            id={item?.data?.id || params.id}
        />
    );
};

export default Detail;
